module.exports = __webpack_public_path__ + "img/clear.571efb01.svg";